module.exports = __webpack_public_path__ + "img/wall_mounted.a762bac2.jpg";